<template> 
    <div> 
        <div class="crumbs" style="margin-left:10px;" hidden="true">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 系统设置
                </el-breadcrumb-item>
                <el-breadcrumb-item>公众号设置</el-breadcrumb-item> 
            </el-breadcrumb>
        </div>
        <div class="container">   
          
            <el-form ref="form" :model="param" size="mini" label-width="200px"  style="margin-top:15px;" width="500px;"> 
                <div  style="font-size:15px;margin-bottom:15px;"> <i class="header-icon el-icon-info" style="color:#F56C6C;margin-right:10px;"></i>公众号开发信息</div>
                    
                <el-form-item label="开发者ID(AppID):" >
                    <span style="margin-left:10px;">{{param.appid==null?'':param.appid}}</span>
                    <el-button  type="primary" class="handle-del" plain icon="el-icon-lx-edit" style="margin-left:30px"   @click="addBind" >编辑</el-button> 
                </el-form-item>  
                <el-form-item label="开发者密码(AppSecret):" >
                    <span style="margin-left:10px;">{{param.appSecret==null?'':param.appSecret}}</span>
                </el-form-item> 
                <div  style="font-size:15px;margin-bottom:15px;"> <i class="header-icon el-icon-info" style="color:#F56C6C;margin-right:10px;"></i>网页授权域名</div>
                <el-form-item label="服务器地址(URL):" >
                    <span style="margin-left:10px;">{{param.rootUrl}}</span>
                </el-form-item>   
                <div  style="font-size:15px;margin-bottom:15px;"> <i class="header-icon el-icon-info" style="color:#F56C6C;margin-right:10px;"></i>服务器配置</div>
                <el-form-item label="服务器地址(URL):" >
                    <span style="margin-left:10px;">{{param.webUrl}}</span>
                </el-form-item>  
                <el-form-item label="令牌(Token):" >
                    <span style="margin-left:10px;">{{param.token}}</span>
                    <el-button  type="primary"  style="margin-left:30px"   @click="updateSet('1')" >更换</el-button>  
                </el-form-item> 
                <el-form-item label="消息加解密密钥(EncodingAESKey):" >
                    <span style="margin-left:10px;">{{param.aesKey}}</span>
                    <el-button  type="primary"  style="margin-left:30px"   @click="updateSet('2')" >更换</el-button>  
                </el-form-item> 
                <el-form-item label="消息加密方式:" >
                    <span style="margin-left:10px;">{{param.keyType==1?"明文模式":param.keyType==2?"兼容模式":"安全模式"}}</span>
                </el-form-item>  
            </el-form> 
        </div>

        <el-dialog :close-on-click-modal="false" title="编辑" :modal-append-to-body='false' :visible.sync="show" width="400px"  center="true"   >
            <el-form ref="form" :model="form" label-width="80px"> 
                <el-form-item label="AppID" >
                    <el-input  v-model.trim="form.appid"  placeholder="请填写开发者ID"></el-input>  
                </el-form-item>   
                <el-form-item label="AppSecret" >
                    <el-input  v-model.trim="form.appSecret"  placeholder="请填写开发者密码"></el-input>   
                </el-form-item>    
            </el-form> 
            <span slot="footer" class="dialog-footer">
                <el-button @click="show = false">取 消</el-button>
                <el-button type="primary" @click="saveChange">确 定</el-button>
            </span>
        </el-dialog>    

        <el-dialog :close-on-click-modal="false" title="修改密码" :modal-append-to-body='false' :visible.sync="show2" width="350px"    center="true"  >
            <el-form ref="form2" :model="form" label-width="80px">    
                <el-form-item label="登录密码" >
                    <el-input type="text" @change="changePass()" v-model.trim="form2.loginPass"   placeholder="请填写登录密码" ></el-input> 
                </el-form-item> 
                <el-form-item label="确认密码" >
                    <el-input type="text" @change="changePass()" v-model.trim="form2.loginPass2"   placeholder="请填写登录密码" ></el-input> 
                </el-form-item> 
                <el-form-item label="验证码">
                    <el-input type="number"  v-model.trim="form2.code"  oninput ="value=value.replace(/[^\d]/g,'')" placeholder="验证码" style="width:100px;"></el-input>
                    <el-button  :type="sendSms.type" :disabled="sendSms.disabled"   :style="sendSms.color"  @click="sendCode" >{{sendSms.content}}</el-button> 
                </el-form-item> 
            </el-form> 
            <span slot="footer" class="dialog-footer">
                <el-button @click="show2 = false">取 消</el-button>
                <el-button type="primary" @click="saveChange2">确 定</el-button>
            </span>
        </el-dialog>   

        <el-dialog :close-on-click-modal="false" title="注销账号" :modal-append-to-body='false' :visible.sync="show3" width="350px"  center="true"  >
            <el-form ref="form2" :model="form3" label-width="80px">    
                <el-form-item label="手机号" >
                    <span>{{param.phone}}</span>
                </el-form-item>  
                <el-form-item label="验证码">
                    <el-input type="number"  v-model.trim="form3.code"  oninput ="value=value.replace(/[^\d]/g,'')" placeholder="验证码" style="width:100px;"></el-input>
                    <el-button  :type="sendSms.type" :disabled="sendSms.disabled"   :style="sendSms.color"  @click="sendCode" >{{sendSms.content}}</el-button> 
                </el-form-item> 
            </el-form> 
            <span slot="footer" class="dialog-footer">
                <el-button @click="show3 = false"> 取 消 </el-button>
                <el-button type="danger" @click="delMemOper">确定注销</el-button>
            </span>
        </el-dialog>    
 

         
        


    </div>
</template>

<script>
import {fetchData,updateData,delMemberDate} from '../../../api/gzhSet';
export default {

    data() {
        return {   
            mid:'',   
            secret:'',
            stationId:'', 
            code1:'',
            code2:'',
            loginName:'',   
            show:false,
            show2:false,
            show3:false,
            loading:false,
            password:'type',
            smsItem:true,
            form: {  
                aesId:'',
                statusId:'', 
            },   
            form2: {  
                aesId:'',
                statusId:'', 
            },  
            form3:{
                
            }, 
            sendSms:{
                code:'-1', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            loginPass:'******',
            avatar:require('/public/base-img.png') ,
            param:{avatar:'',},
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () {
        this.mid = localStorage.getItem('ms_mid');
        this.secret = localStorage.getItem('ms_secret');
        this.stationId = localStorage.getItem('ms_stationId');  
        this.shopCode = localStorage.getItem('ms_shopCode'); 
        this.param.mid = this.mid;
        this.param.stationId = this.stationId; 
        this.param.shopCode = this.shopCode; 
        //查询列表
        this.getData();  
    },

    methods: {    
         //刷新
        refresh(){
            history.go(0); 
        }, 
        addBind(){
            this.form = this.param;
            if(!this.param.avatar ||this.param.avatar=='' ){
                this.form.avatar = this.avatar;
            }
            this.form.loginPass = this.loginPass;
            this.show = true;
        },
        updateSet(i){
            this.form = this.param;
              // 编辑
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            this.form.shopCode = this.shopCode;    
            let code = '';//声明一个空的字符串值用于后面赋值
            const codeLength = 43; //验证码的长度，可以根据个人需求改变
            const random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
            'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
            ]; //随机数的取值范围
            for (let i = 0; i < codeLength; i++) {
            //循环遍历codeLength，值是几，就循环几次
            let index = Math.floor(Math.random() * 36); //Math.floor方法用于返回小于或等于一个给定数字的最大整数；Math.random方法返回 0（含）和 1（不含）之间的随机数
                code += random[index]; //根据索引取得随机数加到code上
            }
            if(i==1){
                this.form.token = code.substring(0,16);
            }else{
                this.form.aesKey = code;
            } 
             
            updateData(this.form).then(res => {  
                if(res.code=='200'){ 
                    this.show = false; 
                    this.$message.success(res.message);
                    this.getData(); 
                }else{
                    this.$message.error(res.message);
                }  
            });
        },
    
        addBind2(){
            this.param.loginPass =  '';
            this.form2 = this.param;  
            this.show2 = true;
        },
        //发送验证码
        sendCode(){  
            //发送短信按钮倒计时提示  
            var that = this;
            var times = 119;
            this.sendSms.disabled = true;
            this.sendSms.type='info';
            this.sendSms.color ="color:#333";
            this.sendSms.sendFag = "1";
            var timeout = false;
            let codeInterval = window.setInterval(function() { 
                if(timeout){ return; }
                that.sendSms.content='倒计时'+times+'s';
                if((times--) <= 0){
                    that.sendSms.type='danger';
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff";
                    window.clearInterval(codeInterval);
                } 
            }, 1000);  

            //发送短信
            this.sendSms.mid = this.mid;
            this.sendSms.stationId = this.stationId; 
            this.sendSms.loginName = this.loginName; 
            this.sendSms.phone = this.param.phone;   
            this.sendSms.code = "-1";
            sendNextCode(this.sendSms).then(res => {
                if(res.code=='200'){ 
                    this.sendSms.code = res.data.code;
                    this.$message.success('发送成功'); 
                    this.getData(this.query);
                }else{ 
                    that.sendSms.type='danger';
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff";
                    //处理该等级绑定的成员
                    this.$message.error(res.message); 
                    timeout=true;
                } 
            }); 
        },
        saveChange(){
            // 编辑
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            this.form.shopCode = this.shopCode;   
            if(!this.form.appid){
                this.$message.error("请输入AppID");
                return;
            }
            if(!this.form.appSecret){
                this.$message.error("请输入AppSecret");
                return;
            }  
            updateData(this.form).then(res => {  
                if(res.code=='200'){ 
                    this.show = false; 
                    this.$message.success(res.message);
                    this.getData(); 
                }else{
                    this.$message.error(res.message);
                }  
            });
        },

        delMem(){
            this.$confirm('注销后您的数据将全部清空，确定要注销账号吗？', '提示', {
                type: 'warning'
            }).then(() => {
                 this.show3 = true;
            }) 
        },
        delMemOper(){
            this.form3.id = this.mid;
            this.form3.stationId = this.stationId; 
            this.form3.phone = this.param.phone;  
            if( !this.form3.code){
                this.$message.error("请输入验证码");
                return;
            }
            if( this.form3.code != this.sendSms.code){
                this.$message.error("验证码不正确");
                return;
            }  
            this.show3 = false; 
            delMemberDate(this.form3).then(res => {  
                if(res.code=='200'){ 
                    this.$message.success("您的账号已注销成功！");
                    localStorage.removeItem('ms_username');
                    localStorage.removeItem('ms_realName');
                    localStorage.removeItem('ms_gid');
                    localStorage.removeItem('ms_mid'); 
                    localStorage.removeItem('ms_shopCode'); 
                    localStorage.removeItem('ms_phone'); 
                    localStorage.removeItem('ms_rid'); 
                    localStorage.setItem('ms_token', true);  
                    this.$router.push('/login');  
                }else{
                    this.show3 = true; 
                    this.$message.error(res.message);
                }  
            });
        }, 
        saveChange2(){
            // 编辑
            this.form2.mid = this.mid;
            this.form2.stationId = this.stationId; 
            this.form2.shopCode = this.shopCode; 
            if( !this.form2.loginPass){
                this.$message.error("请输入密码");
                return;
            } 
            if( !this.form2.loginPass2){
                this.$message.error("请再次输入密码");
                return;
            }
            if( this.form2.loginPass != this.form2.loginPass2){
                this.$message.error("两次密码输入不一致");
                return;
            }
            if( !this.form2.code){
                this.$message.error("请输入验证码");
                return;
            }
            if( this.form2.code != this.sendSms.code){
                this.$message.error("验证码不正确");
                return;
            }  
            this.show2 = false; 
            updateData(this.form2).then(res => {  
                if(res.code=='200'){ 
                    this.$message.success(res.message);
                    this.getData(); 
                }else{
                    this.show2 = true; 
                    this.$message.error(res.message);
                }  
            });
        },

        //查询
        getData(){
            // 获取列表数据   
            fetchData(this.param).then(res => {  
                if(res.code=='200'){ 
                    this.param = res.data; 
                }else{
                    this.$message("暂无数据");
                } 
                
            });
        },  
         
        //主图修改
        chageImage(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => { 
                this.param.avatar = event.target.result;   
            };
            reader.readAsDataURL(file);  
        }, 
        
    }
};
</script>

<style>
.el-message-box{
    width:320px;
}
.handle-del{
    float:right;
    margin-left:15px;
}
 
</style>
